(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('teamsCat', teamsCat);

    /* @ngInject */
    function teamsCat() {
        var directive = {
            bindToController: true,
            templateUrl: 'teams-cat.tpl',
            controller: teamsCatController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                searchModel: '='
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            scope.vm.categories = [];
            scope.vm.data.teams.forEach(function(team) {
                if(!team.team_cat) {return;}
                var idx = scope.vm.categories.findIndex(function(c) {
                    return (c.team_cat || '') == team.team_cat;
                });

                if (idx == -1) {
                    scope.vm.categories.push({
                        team_cat: team.team_cat,
                        sold: 0,
                        fold: true,
                        teams: []
                    });
                    idx = scope.vm.categories.length - 1;
                }
                scope.vm.categories[idx].teams.push(team);
                scope.vm.categories[idx].sold += team.sold;
            });
            scope.vm.categories.sort(function(e1, e2) {
                return e2.sold - e1.sold;
            });
            // console.log(scope.vm.categories);

        }
    }

    /* @ngInject */
    function teamsCatController ($scope) {

    }

})();